import { recordingKeys } from '@/audio/recordingKeys'
import type { SearchResult, Track } from '@/api/types'

export function songKey(song: Pick<Track, 'provider' | 'external_id'>): string {
  return `${song.provider}:${song.external_id}`
}

/** History is newest first; repeat listens should only occupy one shortcut. */
export function uniqueSongs(tracks: Track[], limit: number): Track[] {
  const seen = new Set<string>()
  return tracks.filter((track) => {
    const key = songKey(track)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  }).slice(0, limit)
}

/** Every stored artist can seed recommendations from the local library. */
export function recommendationSeeds(recent: Track[], library: Track[]): Track[] {
  const artists = new Set<string | number>()
  return [...recent, ...library].filter((track) => {
    const id = track.local_artist_id ?? track.artist_id
    if (!id || artists.has(id)) return false
    artists.add(id)
    return true
  }).slice(0, 3)
}

/** Keep discovery distinct from the recent shortcuts and deduplicate recordings. */
export function discoverySongs(results: SearchResult[], recent: Track[], limit = 6): SearchResult[] {
  const keys = new Set(recent.map(songKey))
  const recordings = new Set(recent.flatMap(recordingKeys))
  return results.filter((song) => {
    const key = songKey(song)
    if (keys.has(key) || recordingKeys(song).some(key => recordings.has(key))) return false
    keys.add(key)
    recordingKeys(song).forEach(key => recordings.add(key))
    return true
  }).slice(0, limit)
}
